import { httpsCallable } from 'firebase/functions';
import { functions } from '../../config/firebase';
import {
  ADMIN_PROSPECT_RESPONSE_NOTIFICATIONS_MAX_MARK_READ,
  ADMIN_PROSPECT_RESPONSE_NOTIFICATIONS_PAGE_SIZE,
  buildGetAdminProspectResponseNotificationUnreadCountRequest,
  buildListAdminProspectResponseNotificationsRequest,
  buildMarkAdminProspectResponseNotificationsReadRequest,
  buildRecoverAdminProspectResponseNotificationsRequest,
} from './prospectResponseNotificationsRequest.js';
import {
  parseGetAdminProspectResponseNotificationUnreadCount,
  parseListAdminProspectResponseNotifications,
  parseMarkAdminProspectResponseNotificationsRead,
  parseRecoverAdminProspectResponseNotifications,
} from './prospectResponseNotificationsResponse.js';

export {
  ADMIN_PROSPECT_RESPONSE_NOTIFICATIONS_MAX_MARK_READ,
  ADMIN_PROSPECT_RESPONSE_NOTIFICATIONS_PAGE_SIZE,
  buildGetAdminProspectResponseNotificationUnreadCountRequest,
  buildListAdminProspectResponseNotificationsRequest,
  buildMarkAdminProspectResponseNotificationsReadRequest,
  buildRecoverAdminProspectResponseNotificationsRequest,
};

export async function listAdminProspectResponseNotifications(input) {
  const request = buildListAdminProspectResponseNotificationsRequest(input);
  const callable = httpsCallable(functions, 'listAdminProspectResponseNotifications');
  const result = await callable(request);
  return parseListAdminProspectResponseNotifications(result?.data);
}

export async function getAdminProspectResponseNotificationUnreadCount(input) {
  const request = buildGetAdminProspectResponseNotificationUnreadCountRequest(input);
  const callable = httpsCallable(
    functions,
    'getAdminProspectResponseNotificationUnreadCount',
  );
  const result = await callable(request);
  return parseGetAdminProspectResponseNotificationUnreadCount(result?.data);
}

export async function markAdminProspectResponseNotificationsRead(input) {
  const request = buildMarkAdminProspectResponseNotificationsReadRequest(input);
  const callable = httpsCallable(functions, 'markAdminProspectResponseNotificationsRead');
  const result = await callable(request);
  return parseMarkAdminProspectResponseNotificationsRead(result?.data);
}

export async function recoverAdminProspectResponseNotifications(input) {
  const request = buildRecoverAdminProspectResponseNotificationsRequest(input);
  const callable = httpsCallable(functions, 'recoverAdminProspectResponseNotifications');
  const result = await callable(request);
  return parseRecoverAdminProspectResponseNotifications(result?.data);
}
